<template>
  <b-modal
    id="modal-status-information"
    :title="trackingNumberTitle"
    size="lg"
    scrollable
  >
    <div>
      <b-table
        :items="getErrors(item)"
        :fields="fields"
      >
        <template #cell(message)="data">
          {{ data.item.message || 'error message is undefined' }}
        </template>
      </b-table>
    </div>
  </b-modal>
</template>
<script>

import { BTable } from 'bootstrap-vue'

export default {
  components: {
    BTable,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      fields: [
        { key: 'message', label: 'Error message' },
      ],
    }
  },
  computed: {
    trackingNumberTitle() {
      return `${this.item.parcel?.tracking_number || this.item.tracking_number || this.item.lrn || 'Unknown'} Errors`
    },
  },
  methods: {
    getErrors(item) {
      try {
        const info = typeof item.status_info === 'string'
          ? JSON.parse(item.status_info)
          : item.status_info

        return Array.isArray(info?.errors) ? info.errors : []
      } catch (e) {
        return []
      }
    },
  },
}
</script>
